import { InjectionToken } from '@angular/core';
import type { IPublicClientApplication } from '@azure/msal-browser';

/**
 * Injection token for the MSAL PublicClientApplication instance. Provided by the shell
 * (apps/shell/src/app/app.config.ts) only. Remote MFEs never provide this token — they consume auth state via
 * RemoteAuthFacadeService.
 */
export const MSAL_INSTANCE = new InjectionToken<IPublicClientApplication>('MSAL_INSTANCE');
